<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs class="pl-0 pb-10" :items="breadcrumbs" divider=">"></v-breadcrumbs>
        <v-row>
            <!-- Search advanced -->
          <v-col cols="12">
            <v-expansion-panels focusable v-model="panel1" multiple @change="validate" >
              <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                  ค้นหาจาก Field ทั้งหมด
                  <template v-slot:actions>
                    <v-icon color="cyan"> search </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card elevation="2">
                    <v-card-text>
                      <v-form ref="formDialog" v-model="valid" lazy-validation v-if="dataSearhcReady">
                        <v-row>
                          <v-col cols="4">
                            <v-menu
                              v-model="menuSearch1"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="search.monthYear"
                                  prepend-icon="mdi-calendar"
                                  label="วันที่ชำระ"
                                  v-bind="attrs"
                                  :rules="[rules.required]"
                                  dense
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="search.monthYear"
                                @input="menuSearch1 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="4">
                            <v-select
                              v-model="search.sysproTypeJob"
                              :items="optionSysproTypeJob"
                              label="ประเภทงาน"
                              outlined
                              :rules="[rules.required]"
                              persistent-hint
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="4" v-if="search.sysproTypeJob == 'service'">
                            <v-select
                              v-model="search.typeJob"
                              :items="optionTypeJob"
                              label="ประเภทงาน"
                              outlined
                              chips
                              persistent-hint
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row class="text-right">
                          <v-col cols="12">
                            <v-btn
                              color="warning"
                              depressed
                              :disabled="!valid"
                              @click.prevent="onSearch()"
                            >
                              <v-icon left> search </v-icon>
                              Map Data
                            </v-btn>
                            <v-btn
                              color="error"
                              depressed
                              @click.prevent="clearData()"
                            >
                              <v-icon left> settings_backup_restore </v-icon>
                              Clear
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                      <div v-if="!dataSearhcReady" class="text-center">
                        <v-progress-circular
                          :size="50"
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                        <v-progress-circular
                          :width="3"
                          color="red"
                          indeterminate
                        ></v-progress-circular>
                        <v-progress-circular
                          :size="70"
                          :width="7"
                          color="purple"
                          indeterminate
                        ></v-progress-circular>
                        <v-progress-circular
                          :width="3"
                          color="green"
                          indeterminate
                        ></v-progress-circular>
                        <v-progress-circular
                          :size="50"
                          color="amber"
                          indeterminate
                        ></v-progress-circular>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <v-col cols="12" v-if="dataSearhcReadyTable">
            <v-card elevation="7">
                <v-card-text>
                  <v-data-table
                    :headers="columnsUse"
                    :items="datareport"
                    :items-per-page="100"
                    dense
                  >
                  <template v-slot:[`item.picture`]="{ item }">
                      <v-avatar
                        color="primary"
                        size="40"
                      > <img
                          :src="item.picture"
                          alt="img"
                        ></v-avatar>
                  </template>
                  <!-- <template slot="items" slot-scope="props"> -->
                    <!-- <td>{{ props.item.name }}</td> -->
                    <!-- <td >{{ props.DocHead }}</td> -->
                    <!-- <td class="text-xs-left">{{ props.item.fat }}</td>
                    <td class="text-xs-left">{{ props.item.carbs }}</td>
                    <td class="text-xs-left">{{ props.item.protein }}</td>
                    <td class="text-xs-left">{{ props.item.iron }}</td> -->
                  <!-- </template> -->
                  </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
          </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  // created () {
  //   setInterval(this.getNowGlobal, 1000)
  // },
  data () {
    return {
      PK: '',
      path: '/member/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Vgroup',
          disabled: false,
          href: '/System/VgroupMapCoin'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menuSearch1: false,
      code: 'BCH_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dataSearhcReady: true,
      dataSearhcReadyTable: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [1],
      panel1: [1],
      session: this.$session.getAll(),
      // Search Advanced
      search: {
        typeJob: '',
        monthYear: '',
        sysproTypeJob: ''
      },
      optionSysproTypeJob: [
        { text: 'รถใหม่', value: 'sales' },
        { text: 'รถบริการ', value: 'service' },
        { text: 'รถประกัน', value: 'ins' }
      ],
      optionTypeJob: [
        { text: 'GR', value: 'GR' },
        { text: 'AM', value: 'AM' },
        { text: 'BP', value: 'BP' },
        { text: 'OTH', value: 'OTH' },
        { text: 'PM', value: 'PM' }
      ],
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columnsUse: [],
      columns: [
        { text: 'รูปโปร', value: 'picture' },
        { text: 'ชื่อลูกค้า', value: 'name' },
        { text: 'ยอดชำระ', value: 'amount' },
        { text: 'คะแนน', value: 'coin' },
        { text: 'frameNo', value: 'frameNo' }
      ],
      columnsSales: [
        { text: 'คะแนน', value: 'coin' },
        { text: 'สาขา', value: 'DLR_CD' },
        { text: 'DocHead', value: 'DocHead' },
        { text: 'Frame_no', value: 'Frame_no' },
        { text: 'reg_no', value: 'reg_no' },
        { text: 'invoceNm', value: 'vo_num' },
        { text: 'invoiceDate', value: 'vo_date' },
        { text: 'TOTAL_AMT', value: 'TOTAL_AMT' },
        { text: 'เงินดาวน์', value: 'เงินดาวน์' },
        { text: 'VAT เงินดาวน์', value: 'VAT เงินดาวน์' },
        { text: 'ส่วนลดเงินดาวน์', value: 'ส่วนลดเงินดาวน์' },
        { text: 'งวดแรก', value: 'งวดแรก' },
        { text: 'หักเงินจองรถยนต์', value: 'หักเงินจองรถยนต์' },
        { text: 'ค่าจดทะเบียน', value: 'ค่าจดทะเบียน' },
        { text: 'เงินมัดจำป้ายแดง', value: 'เงินมัดจำป้ายแดง' },
        { text: 'ค่ารถยนต์ซื้อสด', value: 'ค่ารถยนต์ซื้อสด' },
        { text: 'ส่วนลดเงินสด', value: 'ส่วนลดเงินสด' },
        { text: 'ค่าเบี้ยประกันภัยรถยนต์และ พ.ร.บ.', value: 'ค่าเบี้ยประกันภัยรถยนต์และ พ.ร.บ.' },
        { text: 'ฟรีค่าเบี้ยประกันภัยรถยนต์และ พ.ร.บ.', value: 'ฟรีค่าเบี้ยประกันภัยรถยนต์และ พ.ร.บ.' }
      ],
      columnsIns: [
        { text: 'คะแนน', value: 'coin' },
        { text: 'สาขา', value: 'br_code' },
        { text: 'DocHead', value: 'DocHead' },
        { text: 'pt_desc', value: 'pt_desc' },
        { text: 'cust_name', value: 'cust_name' },
        { text: 'CarName', value: 'CarName' },
        { text: 'Frame_no', value: 'Frame_no' },
        { text: 'REG_NO', value: 'REG_NO' },
        { text: 'invoceNm', value: 'vo_num' },
        { text: 'invoiceDate', value: 'vo_date' },
        { text: 'vd_name', value: 'vd_name' },
        { text: 'RcTypeDesc', value: 'RcTypeDesc' },
        { text: 'dn_amt', value: 'dn_amt' },
        { text: 'up', value: 'up' },
        { text: 'slmn_name', value: 'slmn_name' }
      ],
      columnsService: [
        { text: 'คะแนน', value: 'coin' },
        { text: 'สาขา', value: 'Dlr_Code' },
        { text: 'ประเภท Job', value: 'jOB_income' },
        { text: 'DocHead', value: 'DocHead' },
        { text: 'Frame_no', value: 'Frame_no' },
        { text: 'reg_no', value: 'reg_no' },
        { text: 'mxMILEAGE', value: 'mxMILEAGE' },
        { text: 'invoceNm', value: 'vo_num' },
        { text: 'invoiceDate', value: 'vo_date' },
        { text: 'job_num', value: 'job_num' },
        { text: 'job_date', value: 'job_date' },
        { text: 'txn_code', value: 'txn_code' },
        { text: 'total_labor_amt', value: 'total_labor_amt' },
        { text: 'total_labor_discount', value: 'total_labor_discount' },
        { text: 'total_parts_amt', value: 'total_parts_amt' },
        { text: 'total_parts_discount', value: 'total_parts_discount' },
        { text: 'total_others_amt', value: 'total_others_amt' },
        { text: 'total_others_discount', value: 'total_others_discount' },
        { text: 'doc_amt', value: 'doc_amt' },
        { text: 'vat_amt', value: 'vat_amt' },
        { text: 'Total_AMT', value: 'Total_AMT' }
      ],
      dataItem: [],
      datareport: [],
      // End Data Table Config

      // Config Import
      dataItemImportChecKHide: true,
      dataItemImport: [],
      // End Config Import
      // Export Config
      exportType: 'xls',
      exportFileName: 'Master-Branch.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        masBranchID: 'masBranchID',
        masBranchCode: 'masBranchCode',
        masBranchName: 'masBranchName',
        masCompanyCode: 'masCompanyCode',
        masCompanyName: 'masCompanyName'
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      Company: [],
      dataExchange: [],
      valid: false
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    this.getExchange()
  },
  methods: {
    async getExchange () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/productExchangeRate/get?shopId=" + this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataExchange = response.data
          console.log(this.dataExchange)
        })
    },
    validate (Action) {
      this.$nextTick(() => {
        let self = this
        self.$refs.formDialog.validate()
      })
    },
    async onSearch () {
      this.datareport = []
      this.dataSearhcReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get?frameNo=T",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          console.log(rs)
          if (response.data.status === false) {
            this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          } else {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              let url = ''
              if (this.search.sysproTypeJob === 'sales') {
                url = 'https://api.betaskthai.com/vgroupl_api/v1/Bereward/View/getdataSales?vo_date=' + this.search.monthYear + '&Frame_no=' + d.frameNo
                // this.columnsUse = this.columnsSales
              }
              if (this.search.sysproTypeJob === 'service') {
                // this.columnsUse = this.columnsService
                url = 'https://api.betaskthai.com/vgroupl_api/v1/Bereward/View/getdataService?vo_date=' + this.search.monthYear + '&jOB_income=' + this.search.typeJob + '&Frame_no=' + d.frameNo
              }
              if (this.search.sysproTypeJob === 'ins') {
                // this.columnsUse = this.columnsIns
                url = 'https://api.betaskthai.com/vgroupl_api/v1/Bereward/View/getdataIns?vo_date=' + this.search.monthYear + '&Frame_no=' + d.frameNo
              }
              axios
                .get(
                  url,
                  {
                    headers: {
                      'Application-Key':
                  'YWRiNjBhZTY4NDY4YjYyY2ZhZGU3N2NkMTkxOTMwYTg1YmQ5NDhhOGQ4NDE0N2ZiYzZhNTNkZmIzMzUzZTc4Yw'
                  // 'Application-Key': 'TU9bc0d65c72643a12523146b8e4a5cf10dbc9020360f9bbaba32c2f72eaacbe5b13b1717a3c21717882984117ce4e1691'
                    }
                  }
                )
                .then(async (response) => {
                  // console.log(this.session.data.userName)
                  let rs = response.data
                  if (rs.status !== false) {
                    if (this.formSearch.sysproTypeJob === 'sales') {
                      for (var i = 0; i < rs.length; i++) {
                        var d = rs[i]
                        d.coin = 4000
                        this.datareport.push(d)
                      }
                    }
                    if (this.formSearch.sysproTypeJob === 'ins') {
                      for (var z = 0; z < rs.length; z++) {
                        var f = rs[z]
                        if (f.up > 15000) {
                          f.coin = 2000
                        } else {
                          f.coin = 1000
                        }
                        this.datareport.push(f)
                      }
                    }
                    if (this.formSearch.sysproTypeJob === 'service') {
                      for (var x = 0; x < rs.length; x++) {
                        var e = rs[x]
                        if (e.jOB_income === 'GR') {
                          if (e.Total_AMT > 5000) {
                            e.coin = 2000
                          } else {
                            e.coin = 0
                          }
                        }
                        if (e.jOB_income === 'BP') {
                          if (e.Total_AMT >= 6000) {
                            e.coin = 3000
                          } else {
                            if (e.JOB_Type.includes('Gr') || e.JOB_Type.includes('GR')) {
                              if (e.Total_AMT >= 5000) {
                                e.coin = 2000
                              } else {
                                if (e.JOB_Type.includes('Pm') || e.JOB_Type.includes('PM')) {
                                  if (e.Total_AMT >= 1000) {
                                    e.coin = 1000
                                  } else {
                                    e.coin = 0
                                  }
                                } else {
                                  if (e.JOB_Type === 'BP') {
                                    e.coin = 0
                                  }
                                }
                              }
                            } else {
                              if (e.JOB_Type.includes('Pm') || e.JOB_Type.includes('PM')) {
                                if (e.Total_AMT >= 1000) {
                                  e.coin = 1000
                                } else {
                                  e.coin = 0
                                }
                              } else {
                                if (e.JOB_Type === 'BP') {
                                  e.coin = 0
                                }
                              }
                            }
                          }
                        }
                        if (e.jOB_income === 'PM') {
                          if (e.Total_AMT >= 1000) {
                            if (e.JOB_Type.includes('Gr') || e.JOB_Type.includes('GR')) {
                              if (e.Total_AMT >= 5000) {
                                e.coin = 2000
                              } else {
                                e.coin = 1000
                              }
                            } else {
                              e.coin = 1000
                            }
                          } else {
                            e.coin = 0
                          }
                        }
                        if (e.jOB_income === 'OTH') {
                          e.coin = 0
                        }
                        if (e.jOB_income === 'AM') {
                          e.coin = 0
                        }
                        this.datareport.push(e)
                      }
                    }
                    // this.datareport = rs
                    this.columnsUse = this.columns
                    this.dataSearhcReady = true
                    this.dataSearhcReadyTable = true
                    this.panel = []
                    console.log(this.datareport)
                  } else {
                    this.dataSearhcReady = true
                    this.dataSearhcReadyTable = true
                    this.panel = []
                    this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
                  }
                })
              // eslint-disable-next-line handle-callback-err
                .catch((error) => {
                  this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
                  console.log(error)
                  this.errored = true
                  this.dataSearhcReady = true
                })
            }
          }
        })
    },
    async clearData () {
      // this.getDataCompany()
      // eslint-disable-next-line no-redeclare
      // for (var key in this.formAdd) {
      //   if (this.formAdd[key]) {
      //     this.formAdd[key] = ''
      //   }
      // }

      // eslint-disable-next-line no-redeclare
      for (var key in this.search) {
        if (this.search[key]) {
          this.search[key] = ''
        }
      }
    }
  }
}
</script>
<style scope>
</style>



// WEBPACK FOOTER //
// src/components/System/VgroupMapCoin.vue